// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + ({"826":"user-rights-roles","893":"login-home-welcome"}[chunkId] || chunkId) + "." + {"140":"301c1b22","826":"5730ed85","893":"c6241a49"}[chunkId] + ".js";
};